import { getPriceWithCurrencyWithoutRounding } from 'src/utils';
import styles from './ModelPricingDesktopRow.module.scss';

interface ModelPricingDesktopRowProps {
  modelName: string;
  inputPrice?: number;
  outputPrice?: number;
  price?: number;
  currency: string;
  modelDescription?: string;
  defaultModels?: React.ReactNode;
}

export const ModelPricingDesktopRow = ({
  modelName,
  inputPrice,
  outputPrice,
  price,
  currency,
  modelDescription,
  defaultModels,
}: ModelPricingDesktopRowProps) => {
  return (
    <tr className={styles.row}>
      <td className={styles.modelNameCell}>
        <span>{modelName}</span>
        {modelDescription && (
          <span className={styles.description}>{modelDescription}</span>
        )}
        {defaultModels && (
          <div className={styles.defaultModelsWrapper}>{defaultModels}</div>
        )}
      </td>
      <td className={styles.cell}>
        {inputPrice
          ? getPriceWithCurrencyWithoutRounding(inputPrice, currency)
          : ''}
      </td>
      <td className={styles.cell}>
        {outputPrice
          ? getPriceWithCurrencyWithoutRounding(outputPrice, currency)
          : ''}
      </td>

      {/* <td className={styles.cell}>
        {price ? getPriceWithCurrencyWithoutRounding(price, currency) : ''}
      </td> */}
    </tr>
  );
};
